import apiClient  from './Client';

export interface User {
    id: number;
    name: string;
    email: string;
}

export interface LoginResponse {
    token: string;
}

class UserService {

    async Login(postData: any) { 
      console.log(postData);
        try {
          const response = await apiClient.post("/User/Login", postData); 
          console.log(response.data);
          //alert(response.data)
          return response.data;
        } catch (error) {
          throw error; 
        }
       
  }

      // Update this part of your service function
    async RegisterUser(postData: any) {
      try {
        const response = await apiClient.post("/User/register", postData);
        console.log(response);
        return { success: true, message: "Registration successful" };  
      } catch (err: any) {
        console.log(err.response.data.message);
        console.log(err.response?.status);
        if (err.response?.status === 400 && err.response.data.message === "A user is already registered with this email address.") {
          return { success: false, message: "A user is already registered with this email address." }; 
        } else if (err.response?.status === 500) {
          return { success: false, message: "Internal Server Error" };
        }
        return { success: false, message: err.response.data.message };  
      }
    }

      

    async ConfirmRegistration(registerCode: string, email: string) { 
      try {
          const response = await apiClient.get(`/user/register/${registerCode}/${email}`);
          return true; 
      } catch (err: any) {
          if (err.response) {
              if (err.response.status === 400) {
                  console.error("Bad request: Invalid registration code or email.");
                  return "Bad request: Invalid registration code or email."; 
              }
              else if (err.response.status === 404) {
                  console.error("Not found: Registration information not found.");
                  return "Not found: Registration information not found.";
              }
          }
          console.error("There was a problem confirming the email:", err.message);
          return false;
      }
  }
  

      async ResendConfirmationEmail( email: string) { 
        try {
        const response = await apiClient.get("/user/resend-verification-email/"+email); 
          return true;
        } catch (err:any) {
          return false;
        }
      }

      async GetRefreshToken(guid:any) { 
        try {
          const response = await apiClient.get("/User/refresh-token/"+guid);
        
        return response.data;
          
        } catch (err) {
            console.log(err); 
        }
      }

      async SendForgotPassword(email: string) {
        try {
            // Note how we add the email as part of the URL
            const response = await apiClient.post(`/User/send-resetpassword-email/${email}`);
            console.log(response);
            return response;
        } catch (err: any) {
          console.log(err.response);
          if (err.response) {
            return err.response;  
        } else {
            console.log(err); 
            throw err;  
        }
      }
    }
    async VerifyResetPassword(accessCode?: string, email?: string) {
      try {
          console.log("AccessCode:", accessCode, "Email:", email);
          if (!accessCode || !email) {
            console.error("Invalid accessCode or email");
            return;
          }
          const response = await apiClient.get(`/User/verify-reset-password/${accessCode}/${email}`); 
          return response;
          } catch (err) {
              console.log(err); 
          }
    }

      async ResetPassword(postData: any) {
        try { 
          const response = await apiClient.put("/user/reset-password/", postData); 
          return response
            
          } catch (err) {
             console.log(err); 
            
          }
      }
     
}

export default new UserService()

